import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, lazy, useCallback, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
const UserDefined = lazy(() => import("./UserDefined"));
export function useUserDefinedDialog() {
    const [isVisible, setIsVisible] = useState(false);
    const showDialog = useCallback(() => setIsVisible(true), []);
    const dialogElement = (_jsxs(Dialog, { open: isVisible, maxWidth: "xl", fullWidth: true, children: [_jsx(DialogContent, { children: _jsx(Suspense, { children: _jsx(UserDefined, {}) }) }), _jsx(DialogActions, { children: _jsx(Button, { onClick: () => setIsVisible(false), children: "Close" }) })] }));
    return { dialogElement, showDialog };
}
//# sourceMappingURL=useUserDefinedDialog.js.map